import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function Label(_ref) {
  var hide = _ref.hide,
      disabled = _ref.disabled,
      inverse = _ref.inverse,
      inline = _ref.inline,
      optional = _ref.optional,
      size = _ref.size,
      emphasis = _ref.emphasis,
      htmlFor = _ref.htmlFor,
      hideOnDesktop = _ref.hideOnDesktop,
      text = _ref.text;
  var cssClass = classNames({
    'tds-control-label': true,
    'tds-control-label--inverse': inverse,
    'tds-control-label--inline': inline,
    'tds-control-label--hidden': hide,
    'tds-control-label--hidden-on-desktop': hideOnDesktop,
    'tds-control-label--emphasis': emphasis,
    'tds-control-label--sm': size === 'sm',
    'tds-control-label--lg': size === 'lg',
    'tds-control-label--disabled': disabled
  });
  return text ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/label-has-for
  React.createElement("label", {
    className: cssClass,
    htmlFor: htmlFor
  }, text, !!optional && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("span", {
    className: "tds-control-label__optional"
  }, "(optional)"))) : /*#__PURE__*/React.createElement("span", null);
} // Props used in DataListGroup, InputGroup and SelectGroup


Label.propTypes = {
  hide: PropTypes.bool,
  hideOnDesktop: PropTypes.bool,
  disabled: PropTypes.bool,
  inverse: PropTypes.bool,
  inline: PropTypes.bool,
  optional: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  emphasis: PropTypes.bool,
  htmlFor: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
Label.defaultProps = {
  hide: false,
  hideOnDesktop: false,
  inverse: false,
  inline: false,
  emphasis: false,
  optional: false,
  size: 'md',
  htmlFor: '',
  text: '',
  disabled: false
};
export default Label;